function BlueCircles() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 800 1160"
      className="svg"
      preserveAspectRatio="none"
    >
      <g clipPath="url(#a)">
        <mask
          id="b"
          width={1000}
          height={1802}
          x={0}
          y={-321}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'alpha',
          }}
        >
          <path fill="#D9D9D9" d="M0-320.802h877v1801.6H0z" />
        </mask>
        <g mask="url(#b)">
          <ellipse
            cx={902.633}
            cy={580.915}
            fill="#41B6E6"
            rx={900.802}
            ry={899.887}
          />
          <ellipse
            cx={902.632}
            cy={580.915}
            fill="#0072CE"
            rx={767.146}
            ry={766.367}
          />
          <ellipse
            cx={902.633}
            cy={580.915}
            fill="#005EB8"
            rx={613.351}
            ry={612.728}
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h1164v1160H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BlueCircles;
